<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "tableView",
        data() {
            const showType = (row, column, cellValue, index) => {
                let text = '';
                if(cellValue && cellValue.length > 0) {
                    text = cellValue.join(',')
                }
                return text
            };
            const showCycleType = (row, column, cellValue, index) => {
                let text = cellValue === 'count' ? '按支数' :
                    cellValue === 'time' ? '按次数' :
                        '';
                return text
            };
            const showCount = (row, column, cellValue, index) => {
                let text = row.cycle_type === 'count' ? cellValue :
                    row.cycle_type === 'time' ? '' :
                        cellValue;
                return text
            };
            return {
                tableData: [],
                columnData: [
                    {label: '产品名称', prop: 'product_name'},
                    {label: '产品代码', prop: 'product_code'},
                    {label: '产品ID', prop: 'drug_code'},
                    {label: '周期天数', prop: 'cycle_days'},
                    {label: '计算周期方式', prop: 'cycle_type', formatter: showCycleType},
                    {label: '周期用药支数', prop: 'cycle_medication_count', formatter: showCount},
                    {label: '类别', prop: 'drug_type_list', formatter: showType},
                ],
            }
        },
        computed: {

        },
        mounted() {
            this.getTableData()
        },
        methods: {
            ...mapMutations('manageData', {
                setDrugConfigData: 'setDrugConfigData'
            }),
            getTableData() {
                this.httpGet('/product/list').then(res => {
                    this.tableData = res.data.data_list;
                });
            },
            editRow(row) {
                this.setDrugConfigData(row);
                this.$emit('changeTopTab', 'editView')
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>